var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Game--Stats',{attrs:{"result":_vm.profit,"count-players":_vm.countPlayers,"delay":_vm.delay}}),_c('GameStatisticsTable',{attrs:{"items":_vm.statisticsRounds,"pullFunction":_vm.getRounds}}),_c('Base--SideButtons',{attrs:{"save":_vm.save,"back":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }